import React from 'react'
import { Box, Stack, FormControl, DateChooser, Button, Text } from '@/components/lib'

export default function DatetimeInput ({ dataType, value, onChange }) {
  return (
    <Box>
      <FormControl
        helperText={value &&
          <Stack spacing={2} direction='row'>
            {dataType.earliestDate && <Text mr={4} color={value < dataType.earliestDate ? 'red' : 'fg.default'}>Earliest allowed: {dataType.earliestDate}</Text>}
            {dataType.latestDate && <Text color={value > dataType.latestDate ? 'red' : 'fg.default'}>Latest allowed: {dataType.latestDate}</Text>}
          </Stack>}
      >
        <Stack direction='row' spacing={2}>
          <Box maxW='300px'>
            <DateChooser withTime value={value} onChange={(date) => onChange(date ? date.toISOString() : '')} />
          </Box>
          {value && <Button ml={2} onClick={e => onChange(null)}>Clear date</Button>}
        </Stack>
      </FormControl>
    </Box>
  )
}
